export const colors: Record<string, string> = {
  worker: "cyan",
  relativeTime: "magenta",
  text: "green",
  dateFrom: "blue",
  dateTo: "geekblue",
};
